import type { PropsWithChildren } from 'react';
import { Drawer } from './Drawer';

export type DrawerErrorProps = {
  errorTitle: string;
  onClose: () => void;
  className?: string;
};

export const DrawerError = ({ onClose, errorTitle, children, className }: PropsWithChildren<DrawerErrorProps>) => {
  return (
    <Drawer>
      <Drawer.Header onClose={onClose} title={<div className="text-t24-sb">{errorTitle}</div>}></Drawer.Header>
      <Drawer.Content className={className}>{children}</Drawer.Content>
    </Drawer>
  );
};
